import { useQuery } from 'data-fetching-client';
import { useEffect, useState } from 'react';
import { trackError } from '../utils/errorHandler';
import { getSuperstoreConnection } from '../utils/getSuperstoreClient';

/**
 * Wrapper hook around useQuery to implement the cache invalidation strategy
 * stale-while-revalidate using LocalStorage cache to persist cache across
 * page refresh.
 */
export const useQuerySWR = (cacheKey, query, options) => {
  const [cachedData, setCachedData] = useState();
  const response = useQuery(query, options);

  // Read data from cache
  useEffect(() => {
    void getSuperstoreConnection().then(store => {
      store.get(cacheKey).then(data => {
        setCachedData(data);
      }).catch(trackError);
    }).catch(() => {});
  }, [cacheKey]);

  // Update cache with latest response
  useEffect(() => {
    if (!response.loading && response.data) {
      void getSuperstoreConnection().then(store => {
        void store.set(cacheKey, response.data).catch(trackError);
      }).catch(() => {});
    }
  }, [response.loading, cacheKey]); // eslint-disable-line react-hooks/exhaustive-deps

  // Return from API
  if (response.data || response.error) {
    return response;
  }

  // Return from cache
  if (response.loading && cachedData) {
    return Object.assign({}, response, {
      data: cachedData,
      loading: false
    });
  }

  // No cache
  return response;
};